module.exports = __webpack_public_path__ + "static/media/effect-05.a13577ad.png";